/** Import vendor modules **/
import "regenerator-runtime/runtime";

/** Import polyfills here **/
// import "polyfill/Polyfill";

import App from "modules/App";

(() => {
  App.init();
})();
